export const setStudentInfo = (studentInfo) => {
    return {
        type: 'SET_STUDENT_INFO',
        payload: studentInfo
    };
};